module.exports = __webpack_public_path__ + "img/logo_expedia.1a34c8de.png";